/*
 * Portal modal chrome (Corporate Azure) — shared style objects for Chakra
 * Modal sub-parts, so every migrated portal dialog reads the same as the
 * design-system Panel: 14px-radius card, soft panel shadow, a navy title bar
 * with a bottom rule, and a footer with a top rule.
 *
 * These are plain style props (spread via `sx={...}`), NOT a component and NOT
 * a theme override — so they neither touch the frozen `theme.js`/`ui/*` nor
 * change modal chrome globally across the app. Migrated modals opt in by
 * spreading them onto ModalContent / ModalHeader / ModalFooter.
 *
 * Usage:
 *   import { MODAL_CONTENT_SX, MODAL_HEADER_SX, MODAL_FOOTER_SX } from
 *     "../../../components/Portal/portalModalChrome";
 *   <ModalContent sx={MODAL_CONTENT_SX}>
 *     <ModalHeader sx={MODAL_HEADER_SX}>...</ModalHeader>
 *     ...
 *     <ModalFooter sx={MODAL_FOOTER_SX}>...</ModalFooter>
 *   </ModalContent>
 *
 * Pair with the design-system buttons: Cancel -> variant="secondary",
 * primary action -> variant="primary".
 */

export const MODAL_CONTENT_SX = {
  borderRadius: "14px",
  border: "1px solid var(--chakra-colors-portal-line)",
  boxShadow: "0 24px 60px rgba(16,32,51,.18)",
  overflow: "hidden",
};

export const MODAL_HEADER_SX = {
  fontSize: "17px",
  fontWeight: 800,
  letterSpacing: "-0.02em",
  color: "var(--chakra-colors-portal-text)",
  borderBottom: "1px solid var(--chakra-colors-portal-line)",
  bgGradient: "linear(100deg, #F8FBFD 0%, #FFFFFF 60%, #EEF4F8 100%)",
  py: "14px",
  // Reserve room on the right so the absolutely-positioned ModalCloseButton
  // (the X) never overlaps header content/action buttons. Harmless for
  // left-aligned title-only headers; protects any header with corner actions.
  pr: "56px",
};

export const MODAL_FOOTER_SX = {
  borderTop: "1px solid var(--chakra-colors-portal-line)",
  bg: "#FBFCFD",
  gap: "8px",
};
